import { CURRENT_TERMS_VERSION } from "@chessla/shared";

export const TERMS_VERSION = CURRENT_TERMS_VERSION;
export const TERMS_ACCEPTANCE_STORAGE_KEY = "chessla_terms_acceptance_pending";
